import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { ForgeTheme } from '../../hooks/useForgeTheme';

export function ForgeThemeIcon({ theme }: { theme: ForgeTheme }) {
  if (theme === 'light') return <LightModeOutlinedIcon />;
  if (theme === 'beige') return <PaletteOutlinedIcon />;
  return <DarkModeOutlinedIcon />;
}
